export enum UserHierarchyLevel {
	Farmer = 1,
	Consultant = 2,
	Company = 3,
	Master = 4,
}

export enum UserRole {
	Farmer = 'farmer',
	Consultant = 'consultant',
	Company = 'company',
	Master = 'master',
	Admin = 'admin',
}

export interface UserSubscriptionSummary {
	paymentStatus?: string | null;
}

export interface User {
	_id: string;
	email: string;
	name: string;
	role?: UserRole;
	hierarchyLevel: UserHierarchyLevel;
	isMaster?: boolean;
	subscription?: UserSubscriptionSummary | null;
	upgradeSubscription?: UserSubscriptionSummary | null;
}
